<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { Assignment } from '../Assignment';
    import MessageInline from '../../../shared/Messages/MessageInline.svelte';
    import { features } from '../../../shared/Features/features';
    import IconRealisationNote from '../../../shared/Icons/IconRealisationNote.svelte';
    import IconRealisationPhoto from '../../../shared/Icons/IconRealisationPhoto.svelte';
    import IconRealisationDelivery from '../../../shared/Icons/IconRealisationDelivery.svelte';
    import IconRouteInProgress from '../../../shared/Icons/IconRouteInProgress.svelte';
    import IconCheck from '../../../shared/Icons/IconCheck.svelte';
    import SuccessColor from '../../../shared/SuccessColor.svelte';
    import Opacity from '../../../shared/Opacity.svelte';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import { onMount } from 'svelte';
    import { VehiclesApi } from '../../Vehicles/VehiclesApi';
    import { get } from 'svelte/store';
    import { api } from '../../../../stores/api';
    import IconRouteCompleted from '../../../shared/Icons/IconRouteCompleted.svelte';

    export let assignment: Assignment;
    export let extended: boolean = false;
    export let showProgress: boolean = true;

    let realisationStatus: any;
    let completed: boolean = false;

    $: {
        assignment = assignment;
        realisationStatus = Object.assign(
            { notes: 0, photos: 0, deliveries: 0 },
            assignment.getRealisationStatus()
        );
        completed = realisationStatus.deliveries == assignment.getCountRealisations();
    }
</script>

{#if assignment.isDownloaded()}
    {#if extended}
        {#if completed}
            <IconRouteCompleted title={$_('Route is completed by vehicle')} />
            <!--            <SuccessColor>-->
            <!--                <IconCheck title={$_('Route is completed by vehicle')} />-->
            <!--            </SuccessColor>-->
        {:else}
            <div style="margin-right: 5px">
                <IconRouteInProgress title={$_('Route is downloaded by driver')} />
            </div>
        {/if}
    {/if}
    {#if showProgress}
        <IconRealisationDelivery
            count={realisationStatus.deliveries}
            total={assignment.getCountRealisations()}
            scale={0.5}
        />
        {#if realisationStatus.notes > 0}
            <Opacity opacity={0.7}
                ><IconRealisationNote
                    count={realisationStatus.notes}
                    scale={0.4}
                    showCount={extended}
                /></Opacity
            >
        {/if}
        {#if realisationStatus.photos > 0}
            <Opacity opacity={0.7}
                ><IconRealisationPhoto
                    count={realisationStatus.photos}
                    scale={0.5}
                    showCount={extended}
                /></Opacity
            >
        {/if}
    {/if}
{:else if assignment.isRouteModifiedAfterDownload() && showProgress}
    {#if assignment.isLocked()}
        <MessageInline text={$_('route-waiting-for-acceptance')} />
    {:else}
        <WarningColor>
            <MessageInline text={$_('route-uncommited-modifications')} opacity={1} />
        </WarningColor>
    {/if}
{:else if showProgress}
    <MessageInline text={$_('route-waiting-for-download')} />
{/if}
